import {UserStripeService} from "../../../stripe/service/UserStripeService";
import {StripeUserSubscriptionRecord} from "../../../stripe/models/StripeUserSubscriptionRecord";
import {StripeProductName} from "../../../stripe/models/StripeProductNames";
import {ArrayUtil} from "../../../js/util/ArrayUtil";
import {ProductHistoryRecord} from "../../../stripe/models/ProductHistoryRecord";
import {StoreProductState, StoreProductStates} from "../models/StoreProductState";
import {StripeProductHistory} from "../../../stripe/models/StripeProductHistory";
import {SubscriptionUpdateRequest} from "../models/SubscriptionUpdateRequest";
import {IHttpService} from "angular";

export abstract class StoreService<T extends string> {

    protected abstract updateUrl: string;

    protected constructor(protected $http: IHttpService, protected service: UserStripeService) {

    }

    public abstract currentProductState(): Promise<StoreProductStates<T>>;

    protected async userDetails(): Promise<[StripeProductHistory, Array<StripeUserSubscriptionRecord>]> {
        const historyRequest = this.service.productHistory();
        const subscriptionRequest = this.service.currentSubscriptions();
        return await Promise.all([historyRequest, subscriptionRequest]);
    }

    protected hasSubscriptionFor(subscriptions: Array<StripeUserSubscriptionRecord>,
                                 products: Array<StripeProductName>): boolean {
        return subscriptions.map((s) => this.productNamesForSubscription(s))
                            .some((names) => ArrayUtil.matches(names, products));
    }

    protected productNamesForSubscription(subscription: StripeUserSubscriptionRecord): Array<StripeProductName> {
        return subscription.products.map((p) => p.productName);
    }

    protected productState(hasSubscription: boolean, history?: ProductHistoryRecord): StoreProductState {
        if (history == null) {
            return this.noHistoryProduct();
        } else {
            const selectedAndLocked = hasSubscription;
            const inBundle = false;
            const hasTrialAvailable = !history.hasBeenTrialed;
            return {
                selected: selectedAndLocked,
                locked: selectedAndLocked,
                inBundle,
                hasTrialAvailable
            };
        }
    }

    protected noHistoryProduct(): StoreProductState {
        return {
            selected: false,
            inBundle: false,
            locked: false,
            hasTrialAvailable: true
        };
    }

    public async updateSubscriptions(requests: Array<SubscriptionUpdateRequest>): Promise<void> {
        try {
            await this.$http.post(this.updateUrl, requests);
        } catch (e) {
           const error = "Error processing update subscription request.  Please try again later.";
           return Promise.reject(error);
        }
    }
}
